export const LISTE = {
  title: 'Liste des {bons}',
  breadcrumb: {
    liste: 'Liste des {bons}',
  },
  actions: {
    add: 'Nouveau {bon}',
    filtre: 'Filtre',
    delete: 'Supprimer',
    archiver: 'Archiver',
    desarchiver: 'Désarchiver',
    archiverEnMasse: 'Archiver / Désarchiver',
    suppressionEnMasse: 'Suppression en masse',
    deleteCommande: 'Vous ne pouvez pas supprimer un bon d\'origne commande',
  },
  newStock: {
    title: 'Ajouter un {bon}',
    produit: {
      search: 'Ajouter un produit',
    },
  },
  detailStock: {
    title: 'Détails {bon}',
    dateBonEntree: 'Date d\'entrée',
    dateBonSortie: 'Date de sortie',
  },
  generalTitle: {
    generalInformations: 'Informations générales',
    mouvementStock: 'Liste des mouvements',
    commentaire: 'Commentaire',
  },
  informations: {
    dateDeBon: 'Date d{type}',
    lieuDeStockage: 'Lieu de stockage',
    origine: 'Origine',
    commande: 'Commande',
  },
  origineType: {
    bonDivers: 'Bon divers',
    commande: 'Commande',
  },
  tab: {
    produit: 'Produit',
    quantite: 'Quantité',
    lieuDeStockage: 'Lieu de stockage',
    origine: 'Origine',
    commentaire: 'Commentaire',
  },
  delete: {
    title: 'Etes-vous sûr de vouloir supprimer ce mouvement ?',
    suppression: 'Mouvement supprimé avec succès',
    titleStock: 'Etes vous sûr de vouloir de supprimer ce {bon} ?',
    suppressionStock: '{Bon} supprimé avec succès',
  },
  popUpArchivage: {
    titleArchiver: 'Êtes-vous sûr de vouloir archiver ce {bon} ?',
    titleDesarchiver: 'Êtes-vous sûr de vouloir désarchiver ce {bon} ?',
  },
  messages: {
    success: {
      archiver: '{Bon} archivé avec succès.',
      desarchiver: '{Bon} désarchivé avec succès.',
    },
  },
  filtre: {
    title: 'Filtre',
    sousTitle: 'Les filtres seront appliqués à la liste',
    periode: 'Période date de bon',
    origine: 'Origine',
    commande: 'Codes commande',
    actions: {
      appliquer: 'Appliquer',
      reinitialiser: 'Réinitialiser',
    },
    actif: 'Actif',
  },
  bons: {
    bonEntree: 'bon d\'entrée',
    bonSortie: 'bon de sortie',
    bonsEntree: 'bons d\'entrée',
    bonsSortie: 'bons de sortie',
    bonEntreeMaj: 'Bon d\'entrée',
    bonSortieMaj: 'Bon de sortie',
    bonsEntreeMaj: 'Bons d\'entrée',
    bonsSortieMaj: 'Bons de sortie',
  },
};

export const VALIDATION = {
  name: {
    lieuDeStockage: 'Lieu de stockage',
    dateBon: 'La date du bon',
    lieuDeStockageDepartId: 'Le lieu de stockage de depart',
    lieuDeStockageArriveId: 'Le lieu de stockage d\'arrivé',
  },
  noMovementStock: 'La liste des mouvements est vide',
  uniqueMovementStock: 'La liste doit contenir un seul mouvement',
  MovementStockAndLigneCommandeDifferent: 'Différence de produits entre la ligne de commande et le mouvement stock',
  MovementStockAndLigneCommandeDifferentQuantity: 'Différence de quantité entre la ligne de commande et le mouvement stock',
  MovementStockBadType: 'Sens de produit incorrect',
  noStockableProduit: 'La liste des mouvements ne contient pas de produit stockable',
  moduleStockNotActivated: 'Le Module de Stock n\'est pas activé',
  lieuDepartEgalLieuArrive: 'Le lieu de depart est le même que le lieu d\'arrivé',
  lieuDepartNotTierEnfant: 'Le lieu de depart renseigné ne fait pas parti de l\'enseigne',
  lieuDepartNotStockage: 'Le lieu de depart renseigné n\'est pas un lieu de stockage',
  lieuArriveNotTierEnfant: 'Le lieu d\'arrivé renseigné ne fait pas parti de l\'enseigne',
  lieuArriveNotStockage: 'Le Lieu d\'arrivé renseigné n\'est pas un lieu de stockage',
  quantiteNotCorrect: 'La quantité renseignée doit être supérieur à 0',
  produitAchatParDefault: 'Le produit d\'achat par default de votre société n\'est pas correctement parametré',
  produitVenteParDefault: 'Le produit de vente par default de votre société n\'est pas correctement parametré',
  transfertEffectue: 'Le transfert a bien été effectué',
  MouvementSameSens: 'Les produits doivent avoir un sens cohérent avec celui du bon',
};

export const MouvementStock = {
  solde: 'Solde',
  table: {
    origine: 'Origine',
    produit: 'Produit',
    quantite: 'Quantite',
    lienVersBonStock: 'Bon Stock',
    commentaire: 'Commentaire',
  },
  produit: {
    bonDivers: 'Bon Divers',
    commande: 'Commande',
  },
};
